import { useEffect } from "react"
import Header from "../../components/header/header"
import Footer from "../../components/footer/footer"
import { customScript } from "../../common/customscript"
import CartSection from "../../components/cart_section/section";
import SearchModel from "../../components/search_model/search";

const Cart = () => {

    useEffect(() => {
        customScript()
    }, [])

    return (
        <>
            <Header />
            <CartSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Cart